import { Center, Portal, Spinner } from '@chakra-ui/react'
import { lazyLoad } from '../../../../utils/loadable'

const PhotoEditor = lazyLoad(
  () => import('./ImglyEditor'),
  component => component.default,
  {
    fallback: (
      <Portal>
        <Center
          height="100%"
          width="100%"
          position="fixed"
          top="0"
          left="0"
          background="rgba(0, 0, 0, 0.5)"
          zIndex="1001"
        >
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="appPaleGrey"
            color="appBlue"
            size="xl"
          />
        </Center>
      </Portal>
    ),
  },
)

export default PhotoEditor
